import React, { useContext, useState } from "react";
import GloblePopup from "../common/GloblePopup";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";
import { useNavigate } from "react-router";

export default function BannerPopup() {
  const { isBannerOpend, setIsBannerOpen } = useContext(GlobalContext);
  const getImage = (type) =>{
    let pubanner2 = config.pubObj
      if(pubanner2.length > 0){
        let asd = pubanner2.find(item=> item.title === type);    
        // console.log(asd,"asdasdasdasd");
        return asd?.bannerName;  
      }else{
        
        return "";
      }
    }

  const checkIsShow = () => {
    let pubanner2 = config.pubObj
      if(pubanner2.length > 0){
        return true;  
      }else{
        return false;    
      }
  }
  return (
    <div className={`modal home-modal ${checkIsShow() && isBannerOpend ? "open" : ""}`}>
      <div className="modal-dialog ">
        <div className="modal-content">
        <header class="modal-header">
          <div class="close-home-modal" onClick={() => (setIsBannerOpen(false),config.bannerOpen = true,localStorage.setItem("bannerOpen",true))}>
            <i class="fas fa-times"></i>
          </div>
        </header>
          <div className="modal-body">
              <img className="mobile-hide" alt="" src={getImage('Desktop Banner')} />
              <img className="desktop-hide" alt="" src={getImage('Mobile Banner')} />
          </div>
        </div>
      </div>
    </div>
  );
}
